var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconXSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconX",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M797.32 985.882 344.772 1438.43l188.561 188.562 452.549-452.549 452.548 452.549 188.562-188.562-452.549-452.548 452.549-452.549-188.562-188.561L985.882 797.32 533.333 344.772 344.772 533.333z"
    })));
  }
}
IconXSolid.glyphName = 'x';
IconXSolid.variant = 'Solid';
IconXSolid.displayName = 'IconXSolid';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconXSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconXSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconXSolid;
export { IconXSolid };